// Caption below the Calendar legend, explaining the coloring/marker/column
// conventions used across the week grid (CalCell, WeekAvgCell, WeekdayAvgRow).

import React from "react";
import { useTranslation } from "react-i18next";

export const CalendarCaption = () => {
  const { t } = useTranslation("athlete-portal");

  return (
    <p className="np-cal-caption">{t("nutritionPage.progress.calendarLegend.caption")}</p>
  );
};

export default CalendarCaption;
